<div class="borrower-transaction-page">
    <div class="page-header">
        <h1>Transactions</h1>
    </div>

    <div class="tables-container">
        <!-- Upcoming Transactions Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Open Transactions</h2>
            </div>

            <app-borrower-upcoming-transactions-table></app-borrower-upcoming-transactions-table>
        </div>

        <!-- Past Transactions Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Past Transactions</h2>
            </div>

            <app-borrower-past-transactions-table></app-borrower-past-transactions-table>
        </div>
    </div>
</div>